import { post } from './client';
import { API_ENDPOINTS } from '../config/api';

export interface Cart {
  identifier: string;
  complete_sale_url: string;
}

interface CartStartResponse {
  cart?: Cart;
  error?: {
    message?: string;
  };
}

interface CartItem {
  category_id: number;
  item_id: number;
  qty: number;
  account?: number;
}

interface CartSetContentsResponse {
  success?: boolean;
  error?: {
    message?: string;
  };
}

export async function start(loginKey: string) {
  return post<CartStartResponse>(API_ENDPOINTS.CART_START, {
    login_key: loginKey,
  });
}

export async function setContents(cartIdentifier: string, items: CartItem[]) {
  return post<CartSetContentsResponse>(API_ENDPOINTS.CART_SET_CONTENTS, {
    cart_identifier: cartIdentifier,
    items,
  });
}

export default {
  start,
  setContents,
};
